import { useEffect } from "react";

import { BrandReveal } from "@/components/brand/BrandReveal";

export interface ExternalRedirectProps {
  /** Absolute URL to send the visitor to. */
  to: string;
}

/**
 * Sends a visitor to another site, replacing the history entry so Back does not
 * bounce them straight into this redirect again.
 *
 * Used for retired paths that people still have bookmarked or that other sites
 * still link to. A branded reveal covers the hop so the screen never flashes
 * blank.
 */
export function ExternalRedirect({ to }: ExternalRedirectProps) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return <BrandReveal />;
}
